import { Instagram } from 'lucide-react';
import bgImage from '../../assets/dentalBlogImg.jpg'; // Make sure to import your image here
import { Link } from 'react-router';

export default function BlogDetail() {
    return (
        <section className="relative overflow-hidden bg-gradient-to-r from-teal-50 to-lime-50 py-20 px-6 sm:px-10 lg:px-20">
            {/* Decorative Background Image */}
            <img
                src={bgImage}
                alt="Decorative dental background"
                className="absolute top-0 left-0 w-[600px] md:w-[700px] opacity-20 z-[-1] pointer-events-none select-none object-contain"
            />

            {/* Decorative Elements */}
            <div className="absolute top-10 right-10 w-32 h-32 bg-teal-500 rounded-full opacity-10 z-[-1]"></div>
            <div className="absolute bottom-20 left-20 w-40 h-40 bg-lime-500 rounded-full opacity-10 z-[-1]"></div>

            {/* Content */}
            <div className="max-w-5xl mx-auto text-center space-y-6 relative z-10">
                <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight">
                    Our Blog & Smile Stories
                </h1>

                <div className="flex justify-center">
                    <div className="h-1 w-32 bg-teal-500 rounded-full my-2"></div>
                </div>

                <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                    Discover the latest in dental wellness, technology, and real smile transformations—straight from our team and our community. Check back often or follow us on Instagram for more!
                </p>

                <div className="pt-8 flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        to="https://www.instagram.com/pristinesmile.dentalcare/" // Replace with your Instagram URL
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-teal-500 text-white text-base font-medium rounded-lg shadow-md hover:bg-teal-600 transition"
                    >
                        <Instagram className="w-5 h-5" />
                        Follow us on Instagram
                    </Link>
                    
                    <a
                        href="/blog-categories"
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white border-2 border-lime-500 text-lime-600 text-base font-medium rounded-lg shadow-sm hover:bg-lime-50 transition"
                    >
                        Explore Categories
                    </a>
                </div>
                
                {/* Featured Post Teaser */}
                <div className="mt-16 bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                    <div className="text-left">
                        <span className="inline-block px-4 py-1 rounded-full bg-teal-100 text-teal-600 text-sm font-medium mb-4">
                            Featured Post
                        </span>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">
                            The Future of Digital Dentistry in 2025
                        </h2>
                        <p className="text-gray-600 mb-4">
                            Discover how AI, 3D printing, and other cutting-edge technologies are transforming dental care and making treatments faster, more comfortable, and more precise than ever before.
                        </p>
                        <a 
                            href="/blog/digital-dentistry-2025"
                            className="text-teal-500 font-medium hover:text-teal-600 inline-flex items-center"
                        >
                            Read More
                            <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14"></path>
                                <path d="M12 5l7 7-7 7"></path>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}